<template>
  <div class="refund-form">
    <div class="form-title">
      <i class="el-icon-document"></i>
      <span>退款信息</span>
    </div>
    <el-form :model="formData" :rules="rules" ref="refundForm" label-width="100px" size="small">
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="ICCID" prop="iccid">
            <el-input v-model="formData.iccid" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="接待日期" prop="receptionDate">
            <el-input v-model="formData.receptionDate" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="登记人" prop="registrant">
            <el-input v-model="formData.registrant" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="所属团队" prop="team">
            <el-cascader 
              v-model="formData.teamId" 
              :options="teamTreeData" 
              :props="{
                checkStrictly: true,
                value: 'value',
                label: 'label',
                emitPath: false,
                expandTrigger: 'click'
              }" 
              clearable 
              placeholder="请选择所属团队" 
              style="width: 100%" 
              @change="handleTeamChange"
              :show-all-levels="false"
              filterable></el-cascader>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="代理层级" prop="agentLevel">
            <el-input v-model="formData.agentLevel" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="可退金额" prop="refundAmount">
            <el-input v-model="formData.refundAmount" suffix-icon="el-icon-coin">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item label="退款路径" prop="refundPath">
            <el-select v-model="formData.refundPath" placeholder="请选择退款路径" style="width: 100%">
              <el-option label="原路退回" value="original"></el-option>
              <el-option label="支付宝" value="alipay"></el-option>
              <el-option label="微信" value="wechat"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="收款申请人" prop="refundApplicant">
            <el-input v-model="formData.refundApplicant" placeholder="请输入收款申请人"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="收款账号" prop="accountNumber">
            <el-input v-model="formData.accountNumber" placeholder="请输入收款账号"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="退款原因" prop="refundReason">
            <el-input type="textarea" v-model="formData.refundReason" rows="3" placeholder="请输入退款原因"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { getDictData } from '@/api/dict'

export default {
  name: 'RefundForm',
  props: {
    records: {
      type: Array,
      default: () => []
    },
    orderData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      formData: {
        receptionDate: new Date().toLocaleString(),
        registrant: localStorage.getItem('realName') || sessionStorage.getItem('realName'),
        channelSource: '',
        iccid: '请输入ICCID',
        cardNo: '',
        teamId: '',
        teamName: '',
        agentName: '请输入代理姓名',
        createTime: '',
        merchantOrderNo: '',
        refundAmount: '0.00',
        refundPath: '',
        refundApplicant: '',
        accountNumber: '',
        refundDate: '',
        refundReason: ''
      },
      teamList: [], // 团队列表
      teamTreeData: [], // 树形结构的团队数据
      rules: {
        refundPath: [{ required: true, message: '请选择退款路径', trigger: 'change' }],
        refundApplicant: [{ required: true, message: '请输入收款申请人', trigger: 'blur' }],
        accountNumber: [{ required: true, message: '请输入收款账号', trigger: 'blur' }],
        refundReason: [{ required: true, message: '请输入退款原因', trigger: 'blur' }]
      }
    }
  },
  watch: {
    orderData: {
      handler(newVal) {
        if (newVal && Object.keys(newVal).length > 0) {
          this.updateFormData();
        }
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    // 加载团队数据
    this.loadTeamData();
  },
  methods: {
    // 加载团队数据
    async loadTeamData() {
      try {
        const teamData = await getDictData('KFYXTD');
        if (teamData && teamData.status === 1) {
          this.teamList = teamData.data || [];
          console.log('获取到的团队数据:', this.teamList);

          // 转换为树形结构
          this.teamTreeData = this.transformDictDataToTree(this.teamList);
          console.log('团队树形结构:', this.teamTreeData);
        } else {
          console.error('获取团队数据失败');
        }
      } catch (error) {
        console.error('获取团队数据出错:', error);
      }
    },

    // 将字典数据转换为树形结构
    transformDictDataToTree(data) {
      if (!data || !Array.isArray(data)) return [];

      // 创建一个Map来存储所有节点
      const nodeMap = new Map();

      // 第一遍循环：创建所有节点
      data.forEach(item => {
        nodeMap.set(item.itemId, {
          id: item.itemId,
          value: item.itemValue,
          label: item.itemLabel,
          parentId: item.parentId,
          children: []
        });
      });

      // 第二遍循环：建立父子关系
      const rootNodes = [];
      data.forEach(item => {
        const node = nodeMap.get(item.itemId);

        if (item.parentId && item.parentId !== '0' && nodeMap.has(item.parentId)) {
          // 如果有父节点，将当前节点添加到父节点的children中
          const parentNode = nodeMap.get(item.parentId);
          parentNode.children.push(node);
        } else {
          // 如果没有父节点或父节点是根节点，则当前节点是根节点
          rootNodes.push(node);
        }
      });

      return rootNodes;
    },

    // 处理团队选择变化
    handleTeamChange(value) {
      if (!value) {
        // 如果清除选择
        this.formData.teamId = '';
        this.formData.teamName = '';
        return;
      }
      
      // 递归查找选中的团队信息
      const findTeam = (nodes, value) => {
        for (const node of nodes) {
          if (node.value === value) {
            return node;
          }
          if (node.children && node.children.length > 0) {
            const found = findTeam(node.children, value);
            if (found) return found;
          }
        }
        return null;
      };

      const selectedTeam = findTeam(this.teamTreeData, value) ||
        this.teamList.find(item => item.itemValue === value);

      if (selectedTeam) {
        this.formData.teamId = value;
        this.formData.teamName = selectedTeam.label || selectedTeam.itemLabel;
        console.log('选择的团队:', {id: value, name: this.formData.teamName});
      }
    },

    updateFormData() {
      // 更新表单数据
      this.formData.iccid = this.orderData.cardId || '请输入ICCID';
      this.formData.receptionDate = new Date().toLocaleString();

      // 使用父组件传递的登记人信息
      if (this.orderData && this.orderData.registrant) {
        this.formData.registrant = this.orderData.registrant;
      } else {
        // 如果父组件没有传递，则使用之前的逻辑
        this.formData.registrant = localStorage.getItem('realName') || sessionStorage.getItem('realName') || '系统用户';
      }

      // 设置团队信息
      if (this.orderData.teamId) {
        this.formData.teamId = this.orderData.teamId;
        this.formData.teamName = this.orderData.teamName || '';
      } else if (this.orderData.agentThreeId) {
        // 兼容旧数据
        this.formData.teamId = this.orderData.agentThreeId;
        this.formData.teamName = this.orderData.agentThreeName || '';
      }

      this.formData.agentName = this.orderData.agentName || '';

      // 设置可退金额，添加"元"字
      const amount = this.orderData.rechargeMoney || '0.00';
      this.formData.refundAmount = amount + ' 元';
      
      // 设置退款原因
      this.formData.refundReason = this.orderData.refundReason || '';

      console.log('Godaddy组件更新表单数据:', this.formData);
    },

    // 提交表单
    submitForm(requestData) {
      return this.$refs.refundForm.validate(valid => {
        if (valid) {

          console.log('Godaddy组件提交数据:', this.formData);

          // 将表单数据添加到请求数据中
          requestData.refund_reason = this.formData.refundReason;
          requestData.refund_path = this.formData.refundPath;
          requestData.refund_channel = "收款账号";
          requestData.team = this.formData.teamId;
          
          console.log('Godaddy组件提交数据:', requestData);
          return true;
        } else {
          console.error('表单验证失败');
          this.$message.error('请完善退款信息');
          return false;
        }
      });
    }
  },
  mounted() {
    console.log('Godaddy组件挂载完成，records:', this.records);
    console.log('Godaddy组件挂载完成，orderData:', this.orderData);

    // 初始化表单数据
    if (this.orderData && Object.keys(this.orderData).length > 0) {
      this.updateFormData();
    }
  }
}
</script>

<style lang="scss" scoped>
.refund-form {
  margin-top: 20px;
  background-color: #e3ebf4;
  border-radius: 4px;
  padding: 10px;

  .form-title {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    font-size: 14px;
    color: #363739;

    i {
      margin-right: 6px;
      font-size: 16px;
    }
  }

  :deep(.el-form-item) {
    margin-bottom: 18px;

    .el-form-item__label {
      font-weight: normal;
      color: #606266;
      padding-right: 12px;
    }

    .el-form-item__content {

      .el-input__inner,
      .el-select,
      .el-date-editor.el-input {
        width: 100%;
      }
    }
  }

  :deep(.el-input.is-disabled .el-input__inner) {
    color: #606266;
  }
}
</style>
